import { refreshUserAuthenticationSession } from './Idp/core-authentication/refresh-user-auth-session';
import { BetterApiClient } from './better-api-client/BetterApiClient';
import { API_URLS } from './config/api-urls';

const ApiClient = new BetterApiClient({
  baseURL: API_URLS.BASE,
  getRefreshToken: refreshUserAuthenticationSession,
  apiServices: {
    core: API_URLS.CORE,
    backer: API_URLS.BACKER,
    communication: API_URLS.COMMUNICATION,
    compliance: API_URLS.COMPLIANCE,
    feature: API_URLS.FEATURE,
    notification: API_URLS.NOTIFICATION,
    memberhub: API_URLS.MEMBERHUB,
    ledger: API_URLS.LEDGER,
    offer: API_URLS.OFFER,
    payout: API_URLS.PAYOUT,
    store: API_URLS.STORE,
    student: API_URLS.STUDENT,
  },
});

const coreApi = ApiClient.service.core;
export { ApiClient, coreApi };
